import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BatteryWarningIcon, BrainIcon, FlameIcon } from 'lucide-react';
export function PainSection() {
  return <section className="py-24 px-4 bg-[#111827] relative border-t border-[#c9a84c]/10" data-id="element-135">
      <div className="max-w-4xl mx-auto" data-id="element-136">
        <FadeIn data-id="element-137">
          <p className="text-xl md:text-2xl text-[#f5f5f5] leading-relaxed mb-12 font-medium" data-id="element-138">
            ¿Te has despertado últimamente sintiendo que tu cuerpo pesa una
            tonelada, a pesar de haber dormido 8 horas? Te miras al espejo y ves
            una versión de ti que no reconoces: la "barriga cervecera" que no se
            va, la mirada apagada y esa extraña neblina mental que te hace
            perder el hilo en las reuniones de trabajo. No eres tú. No es "la
            edad". Es tu sistema hormonal pidiendo auxilio tras años de estrés,
            mala alimentación y falta de los nutrientes clave que un hombre de
            tu edad necesita.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-bold text-[#c9a84c] mb-8 text-center" data-id="element-140">
            Seamos honestos: el mundo de hoy es una trampa para la testosterona.
          </h2>
          <p className="text-lg text-[#9ca3af] mb-10 text-center max-w-3xl mx-auto" data-id="element-141">
            Tu jefe te exige más, el tráfico de la ciudad te dispara el cortisol
            y la comida que compras en el súper está llena de químicos que
            mimetizan el estrógeno. Si tienes más de 40 años, probablemente has
            notado que:
          </p>
        </FadeIn>

        <div className="space-y-6 mb-12" data-id="element-142">
          <FadeIn delay={0.2} data-id="element-143">
            <div className="bg-[#0a0e1a] border border-[#c9a84c]/20 p-6 rounded-xl flex gap-6 items-start hover:border-[#c9a84c]/50 transition-colors" data-id="element-144">
              <div className="bg-[#111827] p-3 rounded-lg text-[#dc2626] shrink-0" data-id="element-145">
                <BatteryWarningIcon className="w-8 h-8" data-id="element-146" />
              </div>
              <div data-id="element-147">
                <p className="text-lg text-[#f5f5f5]" data-id="element-148">
                  <strong className="text-[#c9a84c]" data-id="element-149">
                    Tu energía se desploma
                  </strong>{' '}
                  a las 3:00 PM y dependes del cuarto café para terminar el día.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-150">
            <div className="bg-[#0a0e1a] border border-[#c9a84c]/20 p-6 rounded-xl flex gap-6 items-start hover:border-[#c9a84c]/50 transition-colors" data-id="element-151">
              <div className="bg-[#111827] p-3 rounded-lg text-[#dc2626] shrink-0" data-id="element-152">
                <BrainIcon className="w-8 h-8" data-id="element-153" />
              </div>
              <div data-id="element-154">
                <p className="text-lg text-[#f5f5f5]" data-id="element-155">
                  <strong className="text-[#c9a84c]" data-id="element-156">
                    Ir al gimnasio se siente como una tortura
                  </strong>{' '}
                  y los resultados son nulos porque tu metabolismo está dormido.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-157">
            <div className="bg-[#0a0e1a] border border-[#c9a84c]/20 p-6 rounded-xl flex gap-6 items-start hover:border-[#c9a84c]/50 transition-colors" data-id="element-158">
              <div className="bg-[#111827] p-3 rounded-lg text-[#dc2626] shrink-0" data-id="element-159">
                <FlameIcon className="w-8 h-8" data-id="element-160" />
              </div>
              <div data-id="element-161">
                <p className="text-lg text-[#f5f5f5]" data-id="element-162">
                  <strong className="text-[#c9a84c]" data-id="element-163">
                    La chispa en tu relación se está apagando
                  </strong>{' '}
                  porque tu deseo sexual simplemente no es el que solía ser.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} data-id="element-164">
          <div className="bg-gradient-to-r from-[#dc2626]/10 to-transparent border-l-4 border-[#dc2626] p-6 rounded-r-xl" data-id="element-165">
            <p className="text-xl text-[#f5f5f5] font-semibold" data-id="element-166">
              Lo peor es que los médicos te dicen que "es normal por la edad".{' '}
              <span className="text-[#dc2626]" data-id="element-167">Mienten.</span> No es normal
              vivir agotado. No es normal aceptar el declive cuando apenas estás
              en el mejor momento de tu carrera y tu vida familiar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}